import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { finalize, shareReplay, tap } from "rxjs/operators";
import { PaymentsApi } from "../api/payment.api";

@Injectable()
export class StripeConfigService {
  constructor(private paymentsApi: PaymentsApi) {}

  private key = "";
  private inFlight$?: Observable<string>;

  getKey(): Observable<string> {
    if (this.key)
      return of(this.key);

    if (this.inFlight$)
      return this.inFlight$;

    this.inFlight$ = this.paymentsApi.getTopUpConfig().pipe(
      tap((value) => (this.key = value)),
      finalize(() => (this.inFlight$ = undefined)),
      shareReplay(1)
    );

    return this.inFlight$;
  }
}
